import { JSONObject, bind } from 'immer-yjs';
import * as Y from 'yjs';

import { Project } from 'src/store/state/projects';

/**
 * Convert a Project object to a Y.Doc.
 *
 * Populates a root Y.Map with the complete Project object using immer-yjs,
 * then unbinds so the doc can be serialized independently.
 *
 * @param project - The Project object to convert
 * @returns A Y.Doc containing the full Project data in its root Y.Map
 */
export const projectToYDoc = (project: Project): Y.Doc => {
  const doc = new Y.Doc();
  const rootMap = doc.getMap('project');

  const binder = bind<JSONObject>(rootMap);

  binder.update(() => {
    // Return a fresh object copy — immer-yjs will diff against empty and apply all keys
    return { ...project } as unknown as JSONObject;
  });

  binder.unbind();
  return doc;
};
